import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-absolute mt-5 top-0 start-0" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = ["src"]

import { onMounted, ref, getCurrentInstance } from "vue";
import { onBeforeRouteUpdate, useRoute } from "vue-router";
import { BlocklyService } from "../../biz/remote/BlocklyService";
import ExecHeader from "../../components/header/ExecHeader.vue";
// import { StringUtils } from '../../utils/StringUtils';
import { SessionUser } from "../../utils/SessionUser";
import { BrowserHandler } from "../../utils/BrowserHandler";
import { BlocklyAframeBuilder } from "../../blockly/BlocklyAframeBuilder";
import { projectContext } from "../../blockly/ProjectContext";
import PositionEditorSection from "./section/PositionEditorSection.vue";
/**
 * プロパティ
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ExecutePage',
  setup(__props) {

const route = useRoute();
const project_id = route.params.project_id as string;
const execPageUrl = BrowserHandler.getExecuteUrl(SessionUser.instance.userId, project_id);
const aframeCode = ref("");
const isAr = ref(false);

onMounted(async () => {
  const project_id = route.params.project_id as string;
  const biz = new BlocklyService();
  const response = await biz.page(project_id, SessionUser.instance.userId);
  aframeCode.value = response.data.userBlockContents.block_code; //StringUtils.htmlDecode();
  isAr.value = BlocklyAframeBuilder.isARCode(aframeCode.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ExecHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(projectContext).enablePositionEditor.value)
          ? (_openBlock(), _createBlock(PositionEditorSection, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("iframe", {
      id: "executeFrame",
      class: "w-100",
      style: {"height":"100vh"},
      src: _unref(execPageUrl)
    }, "\n  ", 8, _hoisted_3)
  ], 64))
}
}

})